import { Component, OnInit } from '@angular/core'

@Component({
    selector: './drgs',
    templateUrl: './drgs.component.html'
})

export class DRGSComponent implements OnInit {

    ngOnInit() {

    }
}